/**
 * Helpers para mostrar/cerrar el teclado en pantalla (OSK) en Windows
 * cuando la app corre dentro de Electron en modo kiosko.
 *
 * Si la app NO esta dentro de Electron (browser normal en desarrollo),
 * estos helpers son no-op y permiten el desarrollo normal.
 *
 * Uso:
 *   <Input onFocus={showKeyboard} onBlur={hideKeyboard} />
 */

export const showKeyboard = () => {
  if (window.electronAPI && window.electronAPI.showKeyboard) {
    window.electronAPI.showKeyboard().catch((err) => {
      console.warn('No se pudo mostrar el teclado:', err);
    });
  }
};

export const hideKeyboard = () => {
  if (window.electronAPI && window.electronAPI.hideKeyboard) {
    window.electronAPI.hideKeyboard().catch((err) => {
      console.warn('No se pudo cerrar el teclado:', err);
    });
  }
};
